import { call, put } from 'redux-saga/effects';
import { get2NDFLByYear } from 'modules/Taps/services/API';
import {
  getNdfl2ByYearFailure,
  getNdfl2ByYearSuccess,
} from 'modules/Taps/components/NDFL3Light/redux/actions';

export default function* getNdfl2ByYearSaga({ payload: { reportYear } }) {
  const { isOk, data, error } = yield call(get2NDFLByYear, reportYear);

  if (isOk) {
    yield put(getNdfl2ByYearSuccess(data));
  } else {
    yield put(getNdfl2ByYearFailure(error));
  }
}
